import styles from "./sixth.module.css"

const SixthSection = () => {
    return(
        <div className={styles.wrapdiv}>
           <div className="controlwidth">
            <div className={styles.section}>
                    <h1>
                        Daily tips & news to help skyrocket your business
                    </h1>
                    <p>
                        It is a long established fact that a reader will be distracted by the 
                        readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal 
                    </p>
                </div>
           </div>
         </div>
    )
}

export default SixthSection